import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Home.css';
// Import local hero image
import homeHero from '../assets/images/home.jpg';

const Home = () => {
    return (
        <div className="home">
            <Header />
            
            {/* HERO SECTION */}
            <section className="hero">
                <div 
                    className="hero-image" 
                    style={{
                        backgroundImage: `linear-gradient(rgba(44,62,80,0.7), rgba(44,62,80,0.7)), url(${homeHero})`
                    }}
                >
                    <div className="hero-overlay"></div>
                </div>
                
                <div className="hero-content">
                    <span className="hero-greeting">Welcome to</span>
                    <h1 className="hero-title">Maison Mosh II</h1>
                    <p className="hero-description">
                        Premium Guest House in Moshoeshoe II, Maseru
                    </p>
                    
                    <div className="hero-cta">
                        <Link to="/rooms" className="btn btn-primary">View Rooms</Link>
                        <Link to="/contact" className="btn btn-outline-light">Contact Us</Link>
                    </div>
                </div>
            </section>

            {/* WELCOME SECTION */}
            <section className="welcome">
                <div className="container">
                    <span className="section-tag">WELCOME TO</span>
                    <h2>Maison Mosh II</h2>
                    <p className="welcome-text">
                        Nestled in the prestigious Moshoeshoe II suburb of Maseru, Maison Mosh II offers 
                        comfortable, well-appointed accommodations for corporate travelers, consultants, 
                        and discerning guests visiting Lesotho.
                    </p>
                    <p className="welcome-text">
                        Our 8 premium rooms provide a peaceful retreat with modern amenities, while our 
                        secure, private setting ensures your peace of mind throughout your stay.
                    </p>
                    <Link to="/about" className="btn btn-link">
                        Learn More About Us
                        <span className="arrow">→</span>
                    </Link>
                </div>
            </section>

            {/* WHAT WE OFFER */}
            <section className="offer">
                <div className="container">
                    <h2>What We Offer</h2>
                    <p className="offer-subtitle">Everything you need for a comfortable stay</p>
                    
                    <div className="offer-grid">
                        <div className="offer-item">
                            <div className="offer-icon">🛏️</div>
                            <h3>Premium Bedding</h3>
                            <p>Comfortable mattresses and quality linens</p>
                        </div>
                        
                        <div className="offer-item">
                            <div className="offer-icon">🛜</div>
                            <h3>Free WiFi</h3>
                            <p>High-speed internet throughout</p>
                        </div>
                        
                        <div className="offer-item">
                            <div className="offer-icon">🚿</div>
                            <h3>Private Bathroom</h3>
                            <p>En-suite in every room</p>
                        </div>
                        
                        <div className="offer-item">
                            <div className="offer-icon">📺</div>
                            <h3>Flat-screen TV</h3>
                            <p>With satellite channels</p>
                        </div>
                        
                        <div className="offer-item">
                            <div className="offer-icon">🅿️</div>
                            <h3>Secure Parking</h3>
                            <p>On-site, gated parking</p>
                        </div>
                        
                        <div className="offer-item">
                            <div className="offer-icon">🛡️</div>
                            <h3>24/7 Security</h3>
                            <p>Round-the-clock protection</p>
                        </div>
                        
                        <div className="offer-item">
                            <div className="offer-icon">🧹</div>
                            <h3>Daily Housekeeping</h3>
                            <p>Fresh towels and cleaning</p>
                        </div>
                        
                        <div className="offer-item">
                            <div className="offer-icon">☕</div>
                            <h3>Tea/Coffee Facilities</h3>
                            <p>In-room refreshments</p>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Home;